import { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';

let currentIntl: IntlShape | undefined;

// Exposes the intl object of the nearest IntlProvider to non-React code via intl() / formatMessage().
// Assigned during render (not in an effect) so children can call formatMessage() on their first render.
const CurrentLocale = ({ children }: { children?: ReactNode }) => {
    currentIntl = useIntl();
    return <div>{children}</div>;
};

export default CurrentLocale;

export function intl(): IntlShape {
    return currentIntl!;
}

export function formatMessage(...args: any) {
    try {
        //console.log('args[0]', args[0]);
        return intl().formatMessage(...(args as Parameters<IntlShape['formatMessage']>));
    } catch (e) {
        console.error('error in formatMessage(...args)', e, args); // TypeError: Cannot read properties of undefined (reading 'formatMessage')
        return args[0]; // id
    }
}
